<template>
  <section class="S8jfhAD">
    <p>All rights reserved. Copyright Boma of Africa © 2023</p>
  </section>

</template>

<script>
  /* eslint-disable */
export default {
name:'Footer'
}
</script>

<style>
.S8jfhAD{background: linear-gradient(227.86deg, #004846 0%, #00DA7A 100%);height:120px;color:#FFF;padding-top:2em}
.S8jfhAD p{padding:1em}
   
    
</style>
